const group = {
  namespaced: true,
  state: {
    groupType: [],
    district: [],
    group: []
  },
  mutations: {
    SET_GROUP (state, options) {
      state.groupType = options.groupType,
      state.district = options.district,
      state.group = options.group
    }
  },
  actions: {
    setGroup (context, options) {
      context.commit('SET_GROUP', {
        groupType: options.groupType,
        district: options.district,
        group: options.group
      })
    }
  }
}
export default group